// ============================================================
// timerNavGuard.ts
// In-app navigation guard for a RUNNING / unsaved activity timer.
//
// A timer modal (AddActivityModal, ComposeEmailModal) registers a guard
// while it holds unsaved time. App-level navigation that would unmount the
// modal WITHOUT going through its own close button — currently the browser
// Back/Forward (popstate) path in App.tsx — asks the guard first. The guard
// shows the Casevo "timer running" popup and later calls exactly one of:
//   proceed() — the user saved or discarded → continue the navigation
//   cancel()  — the user chose "Keep timing" → stay put
//
// Hard reload / tab close are NOT handled here (browsers only allow their
// own native dialog there) — see hooks/useLeavePageWarning.ts.
// ============================================================

export type TimerNavGuard = (proceed: () => void, cancel: () => void) => void

let activeGuard: TimerNavGuard | null = null

// Register the guard; returns an unregister fn (use as an effect cleanup).
export const registerTimerNavGuard = (guard: TimerNavGuard): (() => void) => {
  activeGuard = guard
  return () => {
    if (activeGuard === guard) activeGuard = null
  }
}

export const getTimerNavGuard = (): TimerNavGuard | null => activeGuard
